import React from "react";
import QuantityPrice from "./QuantityPrice";

class Pricing extends React.Component {
  render() {
    let pricingTable = [];

    for (var iter in this.props.pricing) {
      let priceArray = this.props.pricing[iter].field_price.split(",");
      let price = priceArray[0];
      pricingTable.push(
        <QuantityPrice
          quantity={this.props.pricing[iter].field_quantity_threshold}
          pricebreak={+price}
        />,
      );
    }

    return (
      <div className="tool tool--info">
        <h4 className="tool__header">Pricing</h4>
        <div className="pricing-table__quantity-price">
          <div className="pricing__option boldtext">
            <div className="pricing__amount">Quantity</div>

            <div className="pricing__price">Price</div>
          </div>
          {pricingTable}
          <p>
            * additional charges may apply based on style, color or print type
            you select
          </p>
        </div>
      </div>
    );
  }
}

export default Pricing;
